import { LitElement, html, unsafeCSS } from "lit"
import { customElement, property } from "lit/decorators.js"
import styles from "./styles/ephemeris-section-header.css?inline"

/**
 * Section header component for ephemeris tables.
 * Displays a title for a section (e.g., "Top Picks" or "Ephemeris").
 */
@customElement("ephemeris-section-header")
export class EphemerisSectionHeader extends LitElement {
  @property({ type: String }) title = ""

  static styles = unsafeCSS(styles)

  protected render() {
    return html`<h2 class="section-title">${this.title}</h2>`
  }
}




